import React from "react";
import { useNavigate } from "react-router-dom";
import PageContainer from "@/components/layouts/PageContainer";
import useLoginStore from "@/stores/loginStore";
import { Heading } from "@/components/heading";
import { Strong } from "@/components/text";
import { TextLink, Text } from "@/components/text";
import { PlusIcon } from "@heroicons/react/20/solid";
import { Button } from "@/components/button";
import { Input, InputGroup } from "@/components/input";
import { MagnifyingGlassIcon } from "@heroicons/react/16/solid";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/table";

const NoticeListPage: React.FC = () => {
  const { clearToken } = useLoginStore();
  const navigate = useNavigate();

  return (
    <PageContainer>
      <div>
        <Heading>공지사항 목록</Heading>
        <Text>
          This feature is only available to users on the{" "}
          <Strong>Business Plan</Strong>. To upgrade, visit your{" "}
          <TextLink href="#">billing settings</TextLink>.
        </Text>
        <div className="flex justify-between mt-4">
          <Button>
            <PlusIcon />
            Add Notice
          </Button>
          <InputGroup>
            <MagnifyingGlassIcon />
            <Input
              name="search"
              placeholder="Search&hellip;"
              aria-label="Search"
            />
          </InputGroup>
        </div>
        <Table className="mt-4">
          <TableHead>
            <TableRow>
              <TableHeader>Name</TableHeader>
              <TableHeader>Email</TableHeader>
              <TableHeader>Role</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {/* {users.map((user) => (
              <TableRow key={user.handle}>
                <TableCell className="font-medium">{user.name}</TableCell>
                <TableCell>{user.email}</TableCell>
                <TableCell className="text-zinc-500">{user.access}</TableCell>
              </TableRow>
            ))} */}
          </TableBody>
        </Table>
      </div>
    </PageContainer>
  );
};

export default NoticeListPage;
